import PriceService from "../services/price.service";
// import moment from 'moment';

export const price = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    getBrokerFeeSet({ commit }, feeSetId) {
      return PriceService.getBrokerFeeSet(feeSetId).then(
        (resp) => {
          commit("dummy", "getBrokerFeeSet - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "getBrokerFeeSet - error");
          return Promise.reject(error.response);
        }
      );
    },

    getBrokerFeeSets({ commit }, organizationId) {
      return PriceService.getBrokerFeeSets(organizationId).then(
        (resp) => {
          commit("dummy", "getBrokerFeeSets - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "getBrokerFeeSets - error");
          return Promise.reject(error.response);
        }
      );
    },

    createBrokerFeeSet({ commit }, brokerFeeSet) {
      return PriceService.createBrokerFeeSet(brokerFeeSet).then(
        (resp) => {
          commit("dummy", "createBrokerFeeSet - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "createBrokerFeeSet - error");
          return Promise.reject(error.response);
        }
      );
    },

    updateBrokerFeeSet({ commit }, brokerFeeSet) {
      return PriceService.updateBrokerFeeSet(brokerFeeSet).then(
        (resp) => {
          commit("dummy", "updateBrokerFeeSet - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "updateBrokerFeeSet - error");
          return Promise.reject(error.response);
        }
      );
    },

    deleteBrokerFeeSet({ commit }, feeSetId) {
      return PriceService.deleteBrokerFeeSet(feeSetId).then(
        (resp) => {
          commit("dummy", "deleteBrokerFeeSet - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "deleteBrokerFeeSet - error");
          return Promise.reject(error.response);
        }
      );
    },

    getBrokerFeeAmount({ commit }, feeSetId) {
      return PriceService.getBrokerFeeAmount(feeSetId).then(
        (resp) => {
          commit("dummy", "getBrokerFeeAmount - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "getBrokerFeeAmount - error");
          return Promise.reject(error.response);
        }
      );
    },

    createBrokerFeeAmount({ commit }, brokerFeeAmounts) {
      return PriceService.createBrokerFeeAmount(brokerFeeAmounts).then(
        (resp) => {
          commit("dummy", "createBrokerFeeAmount - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "createBrokerFeeAmount - error");
          return Promise.reject(error.response);
        }
      );
    },

    updateBrokerFeeAmount({ commit }, brokerFeeAmounts) {
      return PriceService.updateBrokerFeeAmount(brokerFeeAmounts).then(
        (resp) => {
          commit("dummy", "updateBrokerFeeAmount - success");
          return Promise.resolve(resp);
        },
        (error) => {
          console.log(brokerFeeAmounts);
          commit("dummy", "updateBrokerFeeAmount - error");
          return Promise.reject(error.response);
        }
      );
    },

    deleteBrokerFeeAmount({ commit }, brokerFeeAmounts) {
      return PriceService.deleteBrokerFeeAmount(brokerFeeAmounts).then(
        (resp) => {
          commit("dummy", "deleteBrokerFeeAmount - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "deleteBrokerFeeAmount - error");
          return Promise.reject(error.response);
        }
      );
    },

    getClosingCostFeeTable({ commit }, organizationId) {
      return PriceService.getClosingCostFeeTable(organizationId).then(
        (closingCostFeeTable) => {
          commit("dummyConsole", closingCostFeeTable);
          return Promise.resolve(closingCostFeeTable);
        },
        (error) => {
          commit("dummyConsole", null);
          return Promise.reject(error);
        }
      );
    },

    updateClosingCostFeeTable({ commit }, feeTable) {
      return PriceService.updateClosingCostFeeTable(feeTable).then(
        (closingCostFeeTable) => {
          commit("dummyConsole", closingCostFeeTable);
          return Promise.resolve(closingCostFeeTable);
        },
        (error) => {
          commit("dummyConsole", null);
          return Promise.reject(error.response);
        }
      );
    },

    createClosingCostFeeTable(
      { commit },
      { organizationId, selectedDate, feeTable }
    ) {
      return PriceService.createClosingCostFeeTable(
        organizationId,
        selectedDate,
        feeTable
      ).then(
        (closingCostFeeTable) => {
          commit("dummyConsole", closingCostFeeTable);
          return Promise.resolve(closingCostFeeTable);
        },
        (error) => {
          commit("dummyConsole", null);
          return Promise.reject(error);
        }
      );
    },

    deleteClosingCostFeeTable({ commit }, feeSetId) {
      return PriceService.deleteClosingCostFeeTable(feeSetId).then(
        (closingCostFeeTable) => {
          commit("dummyConsole", closingCostFeeTable);
          return Promise.resolve(closingCostFeeTable);
        },
        (error) => {
          commit("dummyConsole", null);
          return Promise.reject(error);
        }
      );
    },

    getLockPeriod({ commit }, loanNumber) {
      return PriceService.getLockPeriod(loanNumber).then(
        (resp) => {
          commit("dummyConsole", resp);
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummyConsole", null);
          return Promise.reject(error);
        }
      );
    },

    // getScenarioPricing({ commit }, loanNumber) {
    //   return PriceService.getScenarioPricing(loanNumber).then(
    //     (scenario) => {
    //       commit("dummyConsole", scenario);
    //       return Promise.resolve(scenario);
    //     },
    //     (error) => {
    //       commit("dummyConsole", null);
    //       return Promise.reject(error);
    //     }
    //   );
    // },

    getPricingByScenario({ commit }, scenario) {
      return PriceService.getPricingByScenario(scenario).then(
        (scenario) => {
          commit("dummyConsole", scenario);
          return Promise.resolve(scenario);
        },
        (error) => {
          commit("dummyConsole", null);
          return Promise.reject(error.response);
        }
      );
    },

    getProgramOptionFieldByLoanNumber({ commit }, loanNumber) {
      return PriceService.getProgramOptionFieldByLoanNumber(loanNumber).then(
        (resp) => {
          commit("dummyConsole", resp);
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummyConsole", null);
          return Promise.reject(error);
        }
      );
    },

    generateNonQmFindingReport({ commit }, {loanNumber}){
      return PriceService.generateNonQmFindingReport(loanNumber).then(
        resp => {
          commit('dummyConsole', "generateNonQmFindingReport - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "generateNonQmFindingReport - error");
          return Promise.reject(error.response);
        }
      );
    },
    // getResources({ commit }){
    //   return PriceService.getResources().then(
    //     resp => {
    //       commit('getList', resp);
    //       return Promise.resolve(resp);
    //     },
    //     error => {
    //       commit('getList');
    //       return Promise.reject(error);
    //     }
    //   )
    // },

    // uploadResource({ commit }, resource) {
    //   return PriceService.uploadResource(resource).then(
    //     resp => {
    //       commit("uploadResource", resp);
    //       return Promise.resolve(resp);
    //     },
    //     error => {
    //       commit("uploadResource");
    //       return Promise.reject(error);
    //     }
    //   )
    // }
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    },
    dummyConsole(state, obj) {
      console.log(obj);
    },
  },
};
